import { Navigate } from "react-router-dom";
import { all_routes } from "./all_routes";

// Import all page components
import Login from "../pages/auth/Login";
import TwoStepVerification from "../pages/auth/TwoStepVerification";
import AdminDashboard from "../pages/admin/Dashboard";
import AdminUsers from "../pages/admin/Users";
import AdminGuestLinks from "../pages/admin/GuestLinks";
import AdminTestimonials from "../pages/admin/Testimonials";
import UserDashboard from "../pages/user/Dashboard";
import UserRecord from "../pages/user/RecordTestimonial";
import GuestSubmit from "../pages/guest/SubmitTestimonial";
import Unauthorized from "../pages/error/Unauthorized"; // Add this import
import Companies from "../pages/admin/Companies/Companies";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
  },
  {
    path: routes.adminUsers,
    element: <AdminUsers />,
  },
  {
    path: routes.adminGuestLinks,
    element: <AdminGuestLinks />,
  },
  {
    path: routes.adminTestimonials,
    element: <AdminTestimonials />,
  },
  {
    path: routes.adminCompanies, // ADD THIS ROUTE
    element: <Companies />,
  },
  {
    path: routes.userDashboard,
    element: <UserDashboard />,
  },
  {
    path: routes.userRecord,
    element: <UserRecord />,
  },
  {
    path: routes.guestSubmit,
    element: <GuestSubmit />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />, // Add unauthorized route
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
  },
];
